import flatpickr from "flatpickr";

const cache = {};

export default function fxRates( node ) {
	const picker            = node.querySelector('.mutual-rates__datepicker');
	const fixedTable        = node.querySelector('.mutual-rates__table--fixed');
	const incomeGrowthTable = node.querySelector('.mutual-rates__table--income-growth');
	const error             = node.querySelector('.mutual-rates__error');
	const api               = node.dataset.api;

	const maxRefreshes      = 14;

	let selectedDate;
	let refreshCount = 0;

	if ( ! picker ) {
		return;
	}

	const formatDate = ( dateObj ) => {
		const year  = dateObj.getFullYear();
		let   month = dateObj.getMonth() + 1;
		let   date  = dateObj.getDate();

		if ( month < 10 ) {
			month = `0${month}`;
		}

		if ( date < 10 ) {
			date = `0${date}`;
		}

		return `${year}-${month}-${date}`;
	}

	const renderRecord = ( record, table ) => {
		console.log( record, table );
		const row = document.createElement('tr');
		row.className = 'mutual-rates__row';
		row.innerHTML = `
			<td>${ record.label }</td>
			<td>${ record.unit_price_frmt }</td>
			<td>${ record.pay_out_rate }<br><small><em>${ record.effective_date_frmt }</em></small></td>
		`.trim();
		table.appendChild(row);
	}

	const render = ( data ) => {
		console.log( data );
		// remove non-header rows
		Array.from( fixedTable.querySelectorAll('.mutual-rates__row') ).slice(1).forEach( node => node.parentNode.removeChild(node) );
		Array.from( incomeGrowthTable.querySelectorAll('.mutual-rates__row') ).slice(1).forEach( node => node.parentNode.removeChild(node) );

		if ( data.error_message ) {
			node.classList.add('mutual-rates--error');
			error.innerHTML = data.error_message;
			return;
		}

		if ( Array.isArray( data.fixed ) ) {
			data.fixed.forEach( record => renderRecord( record, fixedTable ) );
		}

		if ( Array.isArray( data.incomeGrowth ) ) {
			data.incomeGrowth.forEach( record => renderRecord( record, incomeGrowthTable ) );
		}
	}

	const refresh = ( date ) => {
		if ( cache[ date ] ) {
			console.info( 'cache', date, cache[ date ] );

			render( cache[ date ] );
			refreshCount = 0;
			node.classList.remove('mutual-rates--loading');
			node.classList.remove('mutual-rates--error');
			return;
		}

		node.classList.remove('mutual-rates--error');
		node.classList.add('mutual-rates--loading');

		window.fetch( `${api}/${date || ''}` )
			.then( response => {
				if ( 404 === response.status ) {
					if ( refreshCount < maxRefreshes ) {
						refreshCount++;
						selectedDate.setDate( selectedDate.getDate() - 1 );
						refresh( formatDate( selectedDate ) );
						return { refreshing: true };
					}
				}

				if ( [ 200, 304 ].indexOf( response.status ) > -1 ) {
					const body = response.json();
					refreshCount = 0;

					if ( body.message ) {
						throw new Error( body.message );
					}

					return body;
				} else {
					throw new Error( `${response.status} ${response.statusText}` );
				}
			} )
			.then( data => {
				if ( data.message ) {
					throw new Error( data.message );
				}

				if ( ! data.refreshing ) {
					cache[ date ] = data;
					render( data );
				}

				return data;
			} )
			.catch( ( err ) => {
				console.error( err );
				node.classList.add('mutual-rates--error');

				if ( err.message ) {
					error.innerHTML = `There was an error loading mutual rates: ${err.message}`;
				}
			} )
			.finally( () => {
				if ( refreshCount === 0 ) {
					node.classList.remove('mutual-rates--loading');
				} else if ( refreshCount >= maxRefreshes ) {
					node.classList.add('mutual-rates--error');
					node.classList.remove('mutual-rates--loading');
				}
			} );
	}
	flatpickr(
		picker,
		{
			dateFormat: 'm/d/Y',
			maxDate: 'today',
			defaultDate: 'today',
			onChange: ( selectedDates, dateStr, instance ) => {
				selectedDate = selectedDates[0];
				refresh( formatDate( selectedDate ) );
			},
			onReady: ( selectedDates, dateStr, instance ) => {
				selectedDate = selectedDates[0];

				if ( fixedTable.querySelectorAll('tr').length < 2 ) {
				 	selectedDate.setDate( selectedDate.getDate() - 1 );
				 	refresh( formatDate( selectedDate ) );
				}
			}
		}
	);
}

document.addEventListener( 'DOMContentLoaded', () => document.querySelectorAll( '.mutual-rates' ).forEach( fxRates ) );
